import $ from "jquery";

(() => {
  const removeWCClass = () => {
    const check = {
      login: $(".mi-login").length > 0,
      register: $(".mi-register").length > 0,
    };

    if (check.login || check.register) {
      $(".woocommerce").removeClass("woocommerce");
      $(".woocommerce-page").removeClass("woocommerce-page");
    }
  };

  try {
    removeWCClass();
  } catch (error) {
    console.error(error);
  }
})();
